import { useEffect, useState } from 'react'
import Container from '../../../components/Container'
import { ILog } from 'sierra'
import api from '../../../utils/axios'
import socket from '../../../utils/socket'
import DataGridSkeleton from '../../../components/Skeletons/DataGridSkeleton'
import { alpha, Grid2, Typography, useTheme } from '@mui/material'
import StyledDataGrid from '../../../components/StyledDataGrid'
import * as Colors from "@mui/material/colors";
import { useApp } from '../../../contexts/AppContext'


const SystemLogs = () => {
    const theme = useTheme()
    const { translate, lang } = useApp()

    const [logs, setLogs] = useState<ILog[]>()

    const fetchLogs = () => {
        api.get('/logs').then(res => setLogs(res.data)).catch(console.error)
    }

    useEffect(() => {
        fetchLogs()
        socket.on('logs_changed', fetchLogs)
        return () => {
            socket.off('logs_changed', fetchLogs)
        }
    }, [])

    const columns = [
        {
            field: 'log_id',
            headerName: translate('Log #'),
            // width: 100
            flex: 0.5,
        },
        {
            field: 'user_id',
            headerName: translate('User #'),
            // width: 200,
            flex: 0.5,
        },
        {
            field: 'role',
            headerName: translate('Role'),
            minWidth: 100,
            flex: 0.5,
            valueGetter: (value: string) => translate(value)
        },
        {
            field: 'name',
            headerName: translate('User Name'),
            minWidth: 150,
            flex: 0.7,
        },
        {
            field: 'action',
            headerName: translate('Action'),
            minWidth: 200,
            flex: 4,
        },
        {
            field: 'creation_timestamp',
            headerName: translate('Date/Time'),
            minWidth: 150,
            flex: 1,
            valueGetter: (value: Date) => {
                return new Date(value).toLocaleString(lang === 'ar' ? 'ar-SD' : undefined)
            },
        },]

    const generateRowClass = (backgroundColor: string) => {
        return ({
            // fontSize: 16,
            backgroundColor,
            '&:hover, &.Mui-hovered': {
                backgroundColor: alpha(backgroundColor, 0.2),
                '@media (hover: none)': {
                    backgroundColor: 'transparent',
                },
            },
            color: '#000000',
            '&.Mui-selected': {
                backgroundColor: Colors.grey[400],
                '&:hover, &.Mui-hovered': {
                    backgroundColor: Colors.grey[300],
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: alpha(
                            backgroundColor,
                            0.2 + theme.palette.action.selectedOpacity,
                        ),
                    },
                },
            },
        }
        )
    }

    return (
        <Grid2 container size={'grow'} spacing={2} flexDirection={'column'}>
            <Container container size={'auto'} padding={2} justifyContent={'space-between'}>
                <Grid2>
                    <Typography variant='h4' fontWeight={'bold'} color='primary'>
                        Audit Logs
                    </Typography>
                </Grid2>
            </Container>
            <Container container flexDirection={'column'} flexWrap={'nowrap'} overflow={'auto'} spacing={2} padding={2} sx={{ direction: 'ltr' }}>
                {
                    !logs ? <DataGridSkeleton /> :
                        logs.length == 0 ?
                            <Typography>No orders to show</Typography> :
                            <StyledDataGrid
                                rowSpacingType={'margin'}
                                rows={logs.map((c, i) => ({ ...c, id: i }))}
                                columns={columns}
                                pageSizeOptions={[5, 10, 20]}
                                disableRowSelectionOnClick
                                getRowClassName={({ row }: { row: ILog }) => row.action_type}
                                sx={{
                                    '& .MuiDataGrid-row.update': generateRowClass(Colors.blue[100]),
                                    '& .MuiDataGrid-row.create': generateRowClass(Colors.green[100]),
                                    '& .MuiDataGrid-row.delete': generateRowClass(Colors.red[100]),
                                }}
                            />

                }
            </Container>
        </Grid2>

    )
}

export default SystemLogs